/** My Work strip: ONE Flow exceptions (blockers / SLA breaches) auto-created from live journeys, auto-resolved when the condition clears. */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, Workflow } from "lucide-react";
import api from "@/lib/api";

export default function FlowExceptionsStrip() {
  const [items, setItems] = useState(null); const nav = useNavigate();
  useEffect(() => { api.get("/one-flow/my-work?limit=12").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  if (!items || items.length === 0) return null;
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50/50 p-4" data-testid="flow-exceptions-strip">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.16em] text-amber-800 font-semibold"><Workflow className="h-3.5 w-3.5" /> ONE Flow actions · {items.length}</div>
      <ul className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-1.5">
        {items.map((x) => (
          <li key={x.id}><button onClick={() => x.route && nav(x.route)} className="w-full text-left rounded-lg bg-white border border-amber-100 px-3 py-2 hover:border-amber-300 transition-colors" data-testid={`flow-exception-${x.id}`}>
            <div className="flex items-center gap-2 text-[12px] text-slate-900"><AlertTriangle className={`h-3.5 w-3.5 ${x.severity === "HIGH" ? "text-rose-600" : "text-amber-600"}`} /><b>{x.record_code}</b><span className="text-slate-500 truncate">{x.record_title}</span></div>
            <div className="text-[11px] text-slate-700 mt-0.5">{x.text}</div>
            {x.next_action && <div className="text-[10px] text-sky-800 mt-0.5">→ {x.next_action}</div>}
          </button></li>))}
      </ul>
    </div>
  );
}
